<div class="main-content">
    <div class="main-heading">
        <span>
            <span translate>VEHICLE_LIST</span>
        </span>
        <span class="page-actions text-right" *ngIf="isVehicleRights">
            <a [routerLink]="['./../new']" class="btn btn-success">
                <i class="pi pi-plus"></i>
                <span>
                    <span translate>NEW</span>
                </span>
            </a>
        </span>
    </div>
    <div class="panel-tabs">
        <nav>
            <ul class="nav nav-pills">
                <li [routerLinkActive]="['active']" *ngIf="isVehicleRights">
                    <a [routerLink]="['./all']" translate>ALL</a>
                </li>
                <li [routerLinkActive]="['active']" *ngIf="isHideVehicleRights">
                    <a [routerLink]="['./own']" translate>FOR_YOU</a>
                </li>
            </ul>
        </nav>
    </div>
    <div class="card">
        <div class="card-body">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>